<template>
  <b-form-group :label="value.label">
    <div class="row">
      <div class="col">
        <date-picker v-model="valueFrom" :config="options" placeholder="Van" />
      </div>
      <div class="col">
        <date-picker v-model="valueTo" :config="optionsTo" placeholder="Tot" />
      </div>
    </div>
  </b-form-group>
</template>
<script>
import DatePicker from "vue-bootstrap-datetimepicker";
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';

export default {
  props: ['value'],
  components: { DatePicker },
  data() {
    return {
      options: {
        locale: 'nl-NL',
        format: 'DD-MM-YYYY',
        calendarWeeks: true,
        useCurrent: false,
        showClear: true,
      }
    }
  },
  computed: {
    valueFrom: {
      get: function() {
        if(this.value.value === null){
          return '';
        }

        return this.value.value.split('|')[0];
      },
      set: function(value) {
        this.value.value = value + '|' + this.valueTo;
      }
    },
    valueTo: {
      get: function() {
        if(this.value.value === null){
          return '';
        }

        return this.value.value.split('|')[1];
      },
      set: function(value) {
        this.value.value = this.valueFrom + '|' + value;
      }
    },

    optionsTo: function(){
      let minDate = this.valueFrom;
      minDate = minDate === '' || minDate === 'null' ? false : minDate;

      return {...this.options, minDate};
    }
  }
}

</script>
